import { router } from '@inertiajs/vue3'
import { reactive } from 'vue'
import NProgress from 'nprogress'

// This will be shared between all imports of this mixin.
// So it is "local" in the sense of this mixin
const LocalState = reactive({
    initialized: false,
    loadingCount: 0
})

export default {
    created () {
        // We do it this way so we only have one global event listener otherwise we would
        // Spam the Event Listener Stack with each and every component, as we will use this
        // as a global Mixin, thus this will be called for every component.
        if (LocalState.initialized) {
            return
        }

        LocalState.initialized = true

        // Watch Inertia Events to know when we are loading stuff
        router.on('start', () => {
            LocalState.loadingCount++
        })
        router.on('finish', () => {
            LocalState.loadingCount--
        })

        // Watch axios request/response events
        const axios = window.axios

        if (axios) {
            axios.interceptors.request.use((config) => {
                NProgress.start()
                LocalState.loadingCount++
                return config
            }, (error) => {
                NProgress.done()
                LocalState.loadingCount--
                return Promise.reject(error)
            })
            axios.interceptors.response.use((response) => {
                NProgress.done()
                LocalState.loadingCount--
                return response
            }, (error) => {
                NProgress.done()
                LocalState.loadingCount--
                return Promise.reject(error)
            })
        }
    },
    computed: {
        isInLoadingState () {
            return LocalState.loadingCount > 0
        }
    },
    methods: {
        /**
         * This method can be used to wrap non-inertia async actions which should trigger loading state.
         *
         * @param {function} Function to wrap (must be an async one or at least return a promise.)
         * @returns {Promise}
         */
        async wrapLoading (fn) {
            LocalState.loadingCount++

            try {
                return await fn()
            } catch (e) {
            }

            LocalState.loadingCount--

            return null
        }
    }
}
